import React from 'react'
import Typography from '@material-ui/core/Typography'
import SearchBar from 'material-ui-search-bar'
import Button from '@material-ui/core/Button'
import ContentAdd from 'material-ui/svg-icons/content/add'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { searchTableActions } from '../actions'
import { permissions } from '../utils'
import { withStyles } from '@material-ui/core/styles'

const styles = {
  backButton: {
    marginLeft: '10px'
  },
  searchBar: {},
  crudTitle: {},
  searchBarWrapper: {},
  newButton: {},
  newButtonIcon: {},
  crudHeader: {}
}

export const CrudHeader = props => {
  const {
    classes,
    newResource,
    openModal,
    title = '',
    newLink = '',
    term = '',
    changeTerm,
    token,
    functionality,
    newLinkCallback,
    displayCreateButton = true,
    children,
    rightChildren
  } = props

  return (
    <div className={classes.searchBar}>
      <Typography variant="title" color="inherit" className={classes.crudTitle} noWrap>
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%'
          }}
        >
          {title}
        </div>
      </Typography>

      {children}

      <SearchBar
        placeholder="Buscar..."
        value={term}
        className={classes.searchBarWrapper}
        onChange={value => changeTerm(value)}
        onRequestSearch={value => changeTerm(value)}
      />

      {!!permissions.canEdit({ token, functionality }) && displayCreateButton ? (
        !newLink ? (
          <Button
            onClick={() => {
              newResource()
              openModal()
            }}
            className={classes.newButton}
            component={'a'}
            variant="raised"
            color={'primary'}
          >
            Cadastrar <ContentAdd className={classes.newButtonIcon} />
          </Button>
        ) : (
          <Button
            component={Link}
            to={newLink}
            onClick={newLinkCallback}
            className={classes.newButton}
            color={'primary'}
            variant="raised"
          >
            Cadastrar <ContentAdd className={classes.newButtonIcon} />
          </Button>
        )
      ) : null}

      {rightChildren}
    </div>
  )
}

const mapStateToProps = state => {
  return {
    term: state.searchTable.term
  }
}

const mapDispatchToProps = dispatch => {
  return {
    changeTerm: term => {
      dispatch(searchTableActions.changeTerm(term))
    },
    clearTerm: () => {
      dispatch(searchTableActions.clearTerm())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(CrudHeader))



// WEBPACK FOOTER //
// ./src/components/CrudHeader.js